<template>
    <carousel
      v-bind:scrollPerPage="true"
      v-bind:autoplay="true"
      v-bind:loop="true"
      v-bind:autoplayTimeout=5000
      v-bind:speed=3000
      v-bind:centerMode="true"
      v-bind:per-page-custom="[
        [280, 1],
        [480, 1],
        [780, 2],
        [1024, 3],
      ]"
    >
      <slide class="px-5" v-for="(item, index) in elements" :key="index">
        <div class="relative rounded font-lato max-h-80">
          <a :href="item.city_url">
          <img v-if="app.webp_support"
            class="w-full object-cover"
            style="height: 16rem"
            :src="item.image_webp_url"
            :alt="item.city_name"
            height="256"
            width="500"
          />
          <img v-else
            class="w-full object-cover"
            style="height: 16rem"
            :src="item.image_url"
            :alt="item.city_name"
            height="256"
            width="500"
          />
          <span
          v-if="item.geo_amount !== null"
            class="
              top-0
              left-0
              px-5
              py-1
              font-lato
              text-xs
            absolute
              bg-black bg-opacity-50
              text-white
            "
            >From
            {{ item.geo_amount }} {{item.geo_currency}}
          </span>
          <div class="bottom-0 absolute w-full bg-black p-2 bg-opacity-75">
            <div class="flex flex-row items-center  text-left">
              <svg class="w-4 h-4 text-orange" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"></path></svg>
              <span class="text-white text-left text-xs px-2"
                >{{ item.city_name }}</span>
            </div>

          </div>
        </a>
        </div>
      </slide>
    </carousel>
  </template>

  <script>
  import { Carousel, Slide } from "vue-carousel";
  export default {
    props: ["elements","app"],
    components: {
      Carousel,
      Slide,
    },
  };
  </script>
